import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { baseurImage } from "../../../Baseurl";

export default function ViewNurse() {
  const location = useLocation();
  const navigate = useNavigate();
  const nurse = location.state?.nurse;

  // Helper function to get nurse image URL
  const getNurseImageUrl = (nurse) => {
    if (nurse.personalPhoto && nurse.personalPhoto !== "null" && nurse.personalPhoto !== "undefined") {
      return `${baseurImage}${nurse.personalPhoto}`;
    }
    // Return default avatar if no personal photo
    return "../assets/images/user/avatar-2.jpg";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  if (!nurse) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card table-card">
              <div className="tableHeader">
                <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                    onClick={() => navigate(-1)}
                    title="Back"
                  >
                    &larr;
                  </span>
                  Nurse Details
                </h5>
              </div>
              <div className="card-body text-center">
                <p>No nurse data available</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Nurse Details
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <div className="row justify-content-center mb-4">
                <div className="col-md-12 text-center">
                  <div className="drImg">
                    <img
                      src={getNurseImageUrl(nurse)}
                      alt={nurse.fullName}

                      onError={(e) => {
                        e.target.src = "../assets/images/user/avatar-2.jpg";
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                {[
                  ["Prefix", nurse.prefix || "N/A"],
                  ["First Name", nurse.fullName],
                  ["Last Name", nurse.shortName || "N/A"],
                  ["Email", nurse.email],
                  ["Phone Number", nurse.phoneNumber],
                  ["Civil ID", nurse.civilId],
                  ["Date of Birth", formatDate(nurse.dateOfBirth)],
                  ["Gender", nurse.gender],
                  ["Role", nurse.role],
                  ["License ID", nurse.licenseId || "N/A"],
                  ["Passport", nurse.passport || "N/A"],
                  // ["Specialty", nurse.specialty || "N/A"],

                  // ["Short Name", nurse.shortName || "N/A"],
                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label fw-bold">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={value ?? ""}
                      disabled
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 